// extracted by mini-css-extract-plugin
export var button = "style-module--button--0aKB8";
export var hotkey = "style-module--hotkey--KMH2N";
export var imglyTypoButton = "style-module--imgly--typo-button--rv6Ir";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--hdc7H";
export var imglyTypoH1 = "style-module--imgly--typo-h1--VIqWC";
export var imglyTypoH2 = "style-module--imgly--typo-h2--TfLYu";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--vm+kV";
export var imglyTypoH3 = "style-module--imgly--typo-h3--y9yu3";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--t-OOH";
export var imglyTypoH4 = "style-module--imgly--typo-h4--GwgyB";
export var imglyTypoH5 = "style-module--imgly--typo-h5--49rpk";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--X7iLx";
export var imglyTypoIcon = "style-module--imgly--typo-icon--PB8a5";
export var imglyTypoLink = "style-module--imgly--typo-link--H1HGL";
export var imglyTypoOverline = "style-module--imgly--typo-overline--y0pt9";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--7pVNv";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--q02F4";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--b9zZ7";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--fSAUO";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--keIbx";
export var imglyTypoSubline = "style-module--imgly--typo-subline--F4MmI";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--dZrMb";
export var naviLabelIsLarge = "style-module--navi-label-is-large--uWXFZ";
export var naviLabelIsSmall = "style-module--navi-label-is-small--ZLKPy";
export var root = "style-module--root--dNN9D";